/**
 * Reaction Picker Component
 * NIP-25 Emoji reaction selector
 */

import { useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Smile } from 'lucide-react'
import { REACTION_EMOJIS } from '../../services/reactionService'

interface ReactionPickerProps {
  onSelect: (emoji: string) => void
  disabled?: boolean
}

export function ReactionPicker({ onSelect, disabled }: ReactionPickerProps) {
  const [isOpen, setIsOpen] = useState(false)

  const handleSelect = (emoji: string) => {
    onSelect(emoji)
    setIsOpen(false)
  }

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        disabled={disabled}
        className="p-1 text-gray-400 hover:text-mavi-500 transition-colors disabled:opacity-50"
        title="Reaksiyon ekle"
      >
        <Smile className="w-3.5 h-3.5" />
      </button>

      <AnimatePresence>
        {isOpen && (
          <>
            {/* Backdrop */}
            <div 
              className="fixed inset-0 z-40"
              onClick={() => setIsOpen(false)}
            />
            
            {/* Picker */}
            <motion.div
              initial={{ opacity: 0, scale: 0.9, y: 10 }}
              animate={{ opacity: 1, scale: 1, y: 0 }}
              exit={{ opacity: 0, scale: 0.9, y: 10 }}
              className="absolute bottom-full left-0 mb-2 z-50 bg-white dark:bg-surface-800 rounded-xl shadow-lg border border-surface-200 dark:border-surface-700 p-2"
            >
              <div className="flex gap-1">
                {REACTION_EMOJIS.map((emoji) => (
                  <button
                    key={emoji}
                    onClick={() => handleSelect(emoji)}
                    className="w-8 h-8 flex items-center justify-center text-lg hover:bg-surface-100 dark:hover:bg-surface-700 rounded-lg transition-colors"
                    title={emoji}
                  >
                    {emoji}
                  </button>
                ))}
              </div>
            </motion.div>
          </>
        )}
      </AnimatePresence>
    </div>
  )
}
